function cmpBy<T>(
	arr: T[],
	selector: (item: T) => number,
	cmp: (candidate: number, winner: number) => boolean,
): T | undefined {
	if (arr.length === 0) {
		return undefined;
	}
	let winItem = arr[0];
	let winVal = selector(winItem);
	for (let index = 1; index < arr.length; index++) {
		const currentItem = arr[index];
		const currentVal = selector(currentItem);
		if (cmp(currentVal, winVal)) {
			winVal = currentVal;
			winItem = currentItem;
		}
	}
	return winItem;
}

export function maxBy<T>(
	arr: T[],
	selector: (item: T) => number,
): T | undefined {
	return cmpBy(arr, selector, (a, b) => a > b);
}

export function minBy<T>(
	arr: T[],
	selector: (item: T) => number,
): T | undefined {
	return cmpBy(arr, selector, (a, b) => a < b);
}

export function range(start: number, end: number) {
	return Array.from({ length: end - start + 1 }, (_, index) => start + index); // Inclusive
}

export function toggle<T>(arr: T[], item: T): T[] {
	return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
}

export function partition<T>(
	arr: T[],
	predicate: (item: T) => boolean,
): [T[], T[]] {
	const yes: T[] = [];
	const no: T[] = [];
	for (const item of arr) {
		(predicate(item) ? yes : no).push(item);
	}
	return [yes, no];
}
